import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import EditableToggle from './EditableToggle';

const handleKeyDown = (e, submit, cancel) => {
  // Escape
  if (e.keyCode === 27) {
    cancel();
    e.preventDefault();
    e.stopPropagation();
    if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
  }
  // Ctrl + Enter
  else if (e.keyCode === 13 && e.ctrlKey) {
    submit();
    e.preventDefault();
    e.stopPropagation();
    if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
  }
};
const EditableTextArea = ({
  onChange,
  value = null,
  submitOnBlur = true,
  inputClassName = 'vertical-resize',
  readOnly = false,
  placeholder = '',
  displayValue = null,
  displayClassName = '',
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={readOnly}
    displayValue={displayValue ?? (value ? <pre className="pre-scrollable">{value}</pre> : null)}
    className={displayClassName}
  >
    {({ inputValue, handleChange, inputRef, submit, cancel }) => (
      <textarea
        value={inputValue === null ? '' : inputValue}
        onChange={handleChange}
        ref={inputRef}
        onBlur={submitOnBlur ? submit : cancel}
        onKeyDown={e => handleKeyDown(e, submit, cancel)}
        className={classnames('form-control', inputClassName)}
        placeholder={placeholder}
        autoComplete="off"
        {...rest}
      />
    )}
  </EditableToggle>
);

EditableTextArea.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  submitOnBlur: PropTypes.bool,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  displayClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  displayValue: PropTypes.node,
};

export default EditableTextArea;
